import { useEffect, useState } from 'react'

import fetchMeService from 'utils/fetchMeService'

interface FetchMeResponse {
  data: {
    user: {
      passKeyBannerClosedAt: string | null
    }
  }
}

const usePasskeyPromotionBanner = () => {
  const [passkeyPromotionBannerIsVisible, setPasskeyPromotionBannerIsVisible] = useState(false)

  const onPasskeyBannerClose = async () => {
    const currentDate = Date.now()
    await fetchMeService(
      JSON.stringify({
        query: `mutation { updateUser(input: { passKeyBannerClosedAt: "${currentDate}" }) }`,
      }),
      'POST',
    )
  }

  useEffect(() => {
    const checkBannerVisibility = async () => {
      const response = await fetchMeService(
        JSON.stringify({
          query: '{user {passKeyBannerClosedAt}}',
        }),
        'POST',
      )
      if (!response) {
        return false
      }

      const bannerVisibilityVal: any = (response as FetchMeResponse)?.data?.user?.passKeyBannerClosedAt
      setPasskeyPromotionBannerIsVisible(!bannerVisibilityVal)
    }
    checkBannerVisibility()
  }, [])

  return {
    onPasskeyBannerClose,
    passkeyPromotionBannerIsVisible,
  }
}

export default usePasskeyPromotionBanner
